import React from "react";
import About from "./About";
import NavBar from "./NavBar";
import Carousel from "./Carousel";
import Products from "./Our_Products/Product";
import Footer from "./Footer";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import BatteryCard from "./battery_page/BatteryPage";

function App() {
  return (
    <BrowserRouter>
      <div>
        <Route path="/" component={NavBar} />
        <Route path="/" exact component={Carousel} />
        <Route path="/" exact component={Products} />
        <Route path="/" exact component={About} />
        <Switch>
          <Route path="/products/About" exact component={About} />
          <Route path="/products/:id" exact component={BatteryCard} />
          <Redirect to="/" />
          <Route path="/" component={Footer} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}
export default App;
